import {
  getDirectusField,
  getItemsFromCollection,
  getItemFromCollection,
} from "directus/src/operations";

export async function fetchBillableMeta({ billableId }) {
  try {
    const query = {
      fields: [
        "id",
        "name",
        "type",
        "status",
        "job.id",
        "job.name",
        "job.project.id",
        "job.project.project_id",
        "job.project.name",
        "job.project.sales_coordinator.id",
        "job.project.sales_coordinator.first_name",
        "job.project.sales_coordinator.last_name",
        "job.project.sales_coordinator.avatar",
      ],
    };
    const response = await getItemFromCollection(
      "billables",
      billableId,
      query
    );  

    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchBillableStatuses() {
  try {
    const response = await getDirectusField("billables", "status");
    const data = response.meta.options.choices.map((status) => {
      return { name: status.text, id: status.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchProjects(search = "") {
  try {
    const query = {
      fields: ["id", "name"],
      filter: {
        status: {
          _eq: "active",
        },
      },
      search: search,
      sort: ["name"],
      limit: -1,
    };

    const data = await getItemsFromCollection("projects", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchJobs({ search = "", projectId }) {
  try {
    if (!projectId) {
      // If no projectId is provided, return an empty array (no jobs)
      return [];
    }
    const query = {
      fields: ["id", "name", "project"],
      filter: {
        project: {
          _eq:
            typeof projectId === "object"
              ? projectId.id || projectId._eq
              : projectId,
        },
      },
      search,
      sort: ["name"],
      limit: -1,
    };

    const data = await getItemsFromCollection("jobs", query);
    // Ensure jobs have a 'name' property for display
    return (data || []).map((job) => ({
      ...job,
      name: job.name || job.title || job.id,
    }));
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export function getLatestExtensionDate(extensions) {
  if (!Array.isArray(extensions) || extensions.length === 0) return null;
  const validDates = extensions
    .map((ext) => new Date(ext.end_date || ext.date_created))
    .filter((d) => d instanceof Date && !isNaN(d));
  if (validDates.length === 0) return null;
  return new Date(Math.max(...validDates));
}

export const getEffectiveBillingDate = (extensions, endDate) => {
  let finalDate = endDate;

  if (extensions?.length) {
    const sortedExtensions = extensions.sort(
      (a, b) => new Date(a.date_created) - new Date(b.date_created)
    );
    finalDate = sortedExtensions[sortedExtensions.length - 1]?.billing_date;
  }

  return finalDate;
};
